<template>
    <div id="hero" class="form-container home-step home-step--panel" :ref="stepName" style="position:relative">

        <b-button class="button is-primary next-button" @click="nextStep()">Vraag je pakket aan</b-button>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>

<style scoped>
.home-step {
    background: none;

}
.home-step--panel {
    box-shadow: none;
}
.next-button {
    position: absolute;
    bottom: 5px;
}

</style>
